export class Patterns {
    static email = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    static phone = /^[0-9]{10}$/;
    static alphanumeric = /^[A-Za-z0-9]+$/;
    static alphanumericSpecial = /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/;
    static numeric = /^[0-9]+$/;
    static password = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/;
}